// Shop registry — the vendors in the world, mirroring quest/index.ts + npc/roster.ts.
// Both the client (src/shop.ts panel) and the server (index.ts buy/sell handlers)
// import this to resolve a shop id to its price list. Shops are CONTENT: authored as
// JSON in content/shops/*.json, validated + hydrated by src/content/load.ts. Add a
// shop = a JSON file + `bun run gen` (see content/SCHEMA.md) — no code edits.
import type { ShopSpec } from "./define.ts";
import { loadedShops } from "../content/load.ts";

export { wareOf } from "./define.ts";
export type { ShopSpec, Ware } from "./define.ts";

export const SHOPS: ShopSpec[] = loadedShops;

/** Find a shop by id (linear scan — the list is tiny). */
export function shopById(id: string): ShopSpec | undefined {
  return SHOPS.find((s) => s.id === id);
}
